<template>
    <div id="app">
        <!-- <img src="./assets/logo.png"> -->
        <app-header v-if="showHeader"></app-header>
        <router-view/>
    </div>
</template>

<script>
    import "@babel/polyfill";
    import Header from '@/components/partials/Header';
    import EventBus from '../../frontend/src/components/event-bus';
    var contex;
    export default {
        components: {
            'app-header': Header,
        },
        name: 'App',
        data: () => ({
            showHeader: true,
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function(){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            if ( window.location.pathname == "/") {
                this.showHeader = false;
            }
        },

        methods : {

        }
    }
    EventBus.$on("showHeader", function(data) {
        contex.showHeader = false;
    });
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/App.vue